<template>
  <el-dialog :title="$t('addAgent')" :visible="isShowDialog" @close="onClosePopupButtonClick()" width="600px">
    <div style="margin-bottom: 10px">
      <el-input type="text"
                size="small"
                v-model="keyword"
                @input="isTyping = true"
                :placeholder="$t('keyword')">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <el-table
      :data="agentListDataSource"
      :row-class-name="getRowClassName"
      header-row-class-name="table-header-color"
      v-loading="isTyping"
      style="width: 100%">
      <el-table-column
        type="index"
        width="50"
        :index="getRowNumber">
      </el-table-column>
      <el-table-column
        :label="$t('agentName')">
        <template  slot-scope="scope">
          <span>{{getAgentName(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('type')">
        <template slot-scope="scope">
          <span>{{getAgentTypeName(scope.row.agentTypeId)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('market')">
        <template slot-scope="scope">
          <span>{{getMarketName(scope.row.id)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="right">
        <template slot-scope="scope">
          <el-button v-if="isAdded(scope.row) === false"
                     type="warning" size="small"
                     @click="onAddButtonClick(scope.row)">
            <i v-if="isLoadingList.includes(scope.row.id)"
               class="el-icon-loading"></i>
            <i v-else
               class="el-icon-plus"></i>
            {{ $t('add') }}
          </el-button>
          <el-button v-if="isAdded(scope.row) === true"
                     type="success" size="small"
                     @click="onRemoveButtonClick(scope.row.id)">
            <i class="el-icon-remove minus-icon" style="color: red"></i>
            {{ $t('added') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="filterAgent().length"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change = "changePage">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSaveButtonClick">{{ $t('save') }} ({{ selectedAgentList.length }})</el-button>
      <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { STATUS } from '@/configs/constant'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import i18nMessages from '@/translations/SpecialOffer/components/PopupAgentListComponent.i18n'
import { filterDataByKeyword, getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import { debounce, get } from 'lodash'
import { sortDataList } from '@/helpers'
import AgentContactPersonApi from '@/api/agent/contact-person-api'

export default {
  name: 'PopupAgentListComponent',
  mixins: [AlertViewMixin],
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created: function () {
    this.sortedAgentList = this.agentList.sort((a, b) => {
      return (a.name > b.name) ? 1 : -1
    })
    this.sortedAgentList = sortDataList(this.agentList, this.sortKey, this.sortBy)
    this.getAgentListDataSource()
  },
  data () {
    return {
      isShowDialog: false,
      currentPage: 1,
      pageSize: 5,
      sortKey: 'name',
      sortBy: 'ascending',
      isTyping: false,
      keyword: '',
      sortedAgentList: [],
      agentListDataSource: [],
      selectedAgentIdList: [],
      selectedAgentList: [],
      isLoadingList: []
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
      this._prepareSelectedAgentList()
    },
    keyword: debounce(function () {
      this.isTyping = false
    }, 500),
    isTyping: function (value) {
      if (!value) {
        this.getAgentListDataSource()
      }
    }
  },
  methods: {
    getAgentListDataSource: function () {
      const filteredUserList = this.filterAgent()
      this.currentPage = adjustCurrentPage(filteredUserList.length, this.currentPage, this.pageSize)
      this.agentListDataSource = getDataOnPaging(filteredUserList, this.currentPage, this.pageSize)
    },
    filterAgent: function () {
      const searchKeys = ['name']
      const filteredAgentList = filterDataByKeyword(this.sortedAgentList, this.keyword, searchKeys)
      const filteredAgentTypeList = filterDataByKeyword(this.agentTypeList, this.keyword, searchKeys)
      const filteredMarketList = filterDataByKeyword(this.marketList, this.keyword, searchKeys)

      const agentTypeIdList = filteredAgentTypeList.map(item => item.id)
      const agentIdListInMarket = filteredMarketList.map(item => item.agentIdList)
      const explodeAgentIdListInMarket = []
      agentIdListInMarket.forEach((item) => {
        explodeAgentIdListInMarket.push(...item)
      })

      const agentListByType = this.sortedAgentList.filter((item) => {
        if (agentTypeIdList.includes(item.agentTypeId)) {
          return true
        }

        return false
      })

      const agentListByMarket = this.sortedAgentList.filter((item) => {
        if (explodeAgentIdListInMarket.includes(item.id)) {
          return true
        }

        return false
      })

      const filteredResult = [...new Set([...filteredAgentList, ...agentListByType, ...agentListByMarket])]
      const sortedResult = filteredResult.sort((a, b) => {
        return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1
      })

      return sortedResult
    },
    getRowNumber: function (index) {
      const rowOfPage = index + 1
      return rowOfPage + (this.pageSize * (this.currentPage - 1))
    },
    getAgentTypeName: function (agentTypeId) {
      if (agentTypeId === undefined) {
        return '-'
      }
      const agentType = this.agentTypeList.find(item => item.id === agentTypeId)
      const agentTypeName = get(agentType, 'name', '-')
      return agentTypeName
    },
    getMarketName: function (agentId) {
      const marketList = this.marketList.filter(market => market.agentIdList.includes(agentId))
      if (marketList.length === 0) {
        return '-'
      }

      const marketNameList = marketList.map(market => market.name)
      return marketNameList.join(', ')
    },
    getRowClassName: function ({ row, rowIndex }) {
      if (row.isEnable === 1) {
        return ''
      }
      return 'disable-row'
    },
    isAdded: function (agent) {
      if (!agent) {
        return false
      }
      const isAdded = this.selectedAgentList.some(item => item.id === agent.id)
      return isAdded
    },
    onClosePopupButtonClick: function () {
      this._closePopup()
    },
    onCancelButtonClick: function () {
      this._closePopup()
    },
    changePage: function (page) {
      this.currentPage = page
      this.getAgentListDataSource()
    },
    getAgentName: function (agent) {
      if (agent === undefined) {
        return ''
      }
      return agent.name
    },
    onAddButtonClick: async function (agent) {
      try {
        this.isLoadingList.push(agent.id)
        const contactPersonList = await AgentContactPersonApi.list(agent.id)
        let contactPerson
        if (contactPersonList.length > 0) {
          contactPerson = contactPersonList.find(item => item.isPrimary === STATUS.ENABLE)
          if (!contactPerson) {
            contactPerson = contactPersonList.find(item => item.isSecondary === STATUS.ENABLE)
          }
          if (!contactPerson) {
            contactPerson = contactPersonList[0]
          }
        }
        const newContactPerson = {
          contactPerson: contactPerson
        }
        const newAgent = Object.assign({}, agent, newContactPerson)
        this.selectedAgentList.push(newAgent)
        this.getAgentListDataSource()
      } catch (err) {
        this.alertError(err.message)
      }

      const indexIsLoading = this.isLoadingList.indexOf(agent.id)
      if (indexIsLoading > -1) {
        this.isLoadingList.splice(indexIsLoading, 1)
      }
    },
    onRemoveButtonClick: function (agentId) {
      const index = this.selectedAgentList.findIndex(item => item.id === agentId)
      this.selectedAgentList.splice(index, 1)
      this.getAgentListDataSource()
    },
    onSaveButtonClick: function () {
      this.keyword = ''
      this.isShowDialog = false
      this.$emit('onSaveSelectAgent', this.selectedAgentList)
      this._closePopup()
    },
    _prepareSelectedAgentList: function () {
      const selectedAgentList = get(this.specialOfferDetail, 'agentList', [])
      this.selectedAgentList = [...selectedAgentList]
    },
    _closePopup: function () {
      this.keyword = ''
      this.isShowDialog = false
      this.$emit('onClose')
      this.getAgentListDataSource()
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
